import { Icon } from "components/shared/icon/Icon";
import React from "react";
import { RemoteParticipantData } from "store/remote-participants/types";
import styles from "./ParticipantInfo.module.css";

interface ParticipantInfoProps {
  participantData: RemoteParticipantData;
  isDominantSpeaker?: boolean;
}
export const ParticipantInfo: React.FC<ParticipantInfoProps> = ({
  participantData,
  isDominantSpeaker,
}) => {
  return (
    <div className={styles["participant-identity-large"]}>
      <span className={styles["icon-wrapper"]}>
        <Icon
          className={`${styles["user-icon"]} ${
            isDominantSpeaker ? styles["dominant"] : ""
          }`}
          id="profile"
        ></Icon>
      </span>
      <span className={styles["identity-text"]}>
        {participantData.identity}
      </span>
      <span className={styles["participant-state-icons"]}>
        {!participantData?.audioIsEnabled && (
          <span className={styles["icon-wrapper"]}>
            <Icon
              className={styles["muted-participant"]}
              id="microphone"
            ></Icon>
          </span>
        )}
        {(!participantData.videoIsEnabled || participantData.isSwitchedOff) && (
          <span className={styles["icon-wrapper"]}>
            <Icon
              className={styles["hidden-participant"]}
              id="video-camera"
            ></Icon>
          </span>
        )}
      </span>
    </div>
  );
};
